/** Asserts that a case is impossible, both at type-inference- and at run-time.
 *
 * Use to guarantee exhaustiveness of conditionals (e.g. with a switch statement).
 * If not all cases are handled by code, this function call will fail type-checking
 * at point of use.
 *
 * Usage:
 *
 * ```
 * switch (thing) {
 *   // ...cases
 *   default:
 *     throw assertNever(thing);
 * }
 * ```
 *
 * Unlike `assertNever` in `@p0security/core/util`, this does not log the
 * offending value: this package cannot depend on the logger.
 */
export const assertNever = (_value: never) =>
  new Error("Unexpected code state: value had unexpected type");
